//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CaseOpening, Award } from "@/components/UI";
import CaseOpeningMore from "../openMoreCase.vue";
import RewardModal from "../../components/RewardModal/index.vue";
import userImg from "@/assets/images/user/ava_none.jpg";
import { conversion } from "@/tool";
import { mapState, mapMutations } from "vuex";
import open_sound from "@/assets/audio/unlock.mp3";
import run_sound from "@/assets/audio/roll.mp3";
import win_sound from "@/assets/audio/battlewin.ogg";
import lose_sound from "@/assets/audio/lose.ogg";
export default {
  name: "OpenMultiplePeopleCase",
  data() {
    return {
      showDialog: false,
      openMultiplePeopleItemBg: require("@/assets/images/case/bg-2-m.jpg"),
      openMultiplePeopleItemBg1: require("@/assets/images/case_opening_background_1.png"),
      is_jump_multiplePeople_animation: false,
      MultiplePeopleList: [],
      MPIdList: [],
      userImg,
      isAwardRunning: false,
      award_people_awards: [],
      /** 音乐 */
      sounds: [],
      AwardPlayersIdList: [],
      currentWidth: 0,
      MultipleMorePeopleList: [],
      conHeight: "",
      currentMPCTabs: 1,
      isOverShow: false,
      autoNewMPCCaseOpen: false,
    };
  },
  props: {
    value: {
      type: Boolean,
      defalut: false,
    },
    case_opened_awards: {
      type: Array,
      defalut: () => [],
    },
    players: {
      type: Array,
      defalut: () => [],
    },
    //自动开箱
    autoMPCCaseOpen: {
      type: Boolean,
      defalut: false,
    },
  },
  filters: {
    conversion,
  },
  components: {
    "p-case-opening": CaseOpening,
    "p-case-opening-more": CaseOpeningMore,
    "c-award": Award,
    "c-RewardModal": RewardModal,
  },
  watch: {
    value: {
      handler(v) {
        this.oninitData();
        this.showDialog = v;
        if (v) {
          this.$nextTick(() => {
            this.currentWidth =
              this.$refs.openMultiplePeopleContainer.offsetWidth; // 获取当前设备宽度
            this.conHeight = `${
              Number(this.matchPhoneMedia ? 550 : 660) -
              65 -
              this.$refs.multiplePeople0.offsetHeight -
              this.$refs.multiplePeople1.offsetHeight -
              this.$refs.multiplePeople2.offsetHeight -
              this.$refs.multiplePeople3.offsetHeight
            }px`;
          });
        }
      },
      deep: true,
      immediate: true,
    },
    showDialog(v) {
      this.$emit("on-sync", v);
    },
    autoMPCCaseOpen(val) {
      this.autoNewMPCCaseOpen = val;
    },
  },
  computed: {
    ...mapState(["user", "config", "isMute"]),
    // 判断当前是否是手机端
    matchPhoneMedia() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
    curUserRealId() {
      return parseInt(this.user.id );
    },
  },
  model: {
    prop: "value",
    event: "on-sync",
  },
  async created() {
    this.is_jump_multiplePeople_animation =
      sessionStorage.getItem("is_jump_multiplePeople_animation") === "true";
    var sounds = {
      open: new Audio(open_sound),
      run: new Audio(run_sound),
      win: new Audio(win_sound),
      lose: new Audio(lose_sound),
    };
    this.sounds = sounds;
  },
  methods: {
    ...mapMutations(["setSpinShow", "setloginModal", "setPayModal"]),
    async oninitData() {
      this.MultiplePeopleList = [];
      this.MPIdList = [];
      this.MultipleMorePeopleList = [];
      await this.players.forEach((player_item) => {
        let obj = {
          ...player_item,
          itempic: player_item.avatar,
          itemname: player_item.name,
          textContent: `${conversion(player_item.amount)}(${
            player_item.ratio
          }%)`,
          rarity: 1,
        };
        this.MultiplePeopleList.push(obj);
        this.MPIdList.push(player_item.id);
      });
      console.log("case_opened_awards==", this.case_opened_awards);
      // console.log('MultiplePeopleList==',this.MultiplePeopleList)
      // console.log('MultipleMorePeopleList==',this.MultipleMorePeopleList)
      if (this.autoNewMPCCaseOpen) {
        setTimeout(() => {
          this.onMPCOpenAWardHandler();
          this.autoNewMPCCaseOpen = false;
        }, 500);
      }
    },
    onCloseHand() {
      this.showDialog = false;
    },
    async onMPCOpenAWardHandler() {
      // 未登录处理
      if (!this.user.nickname) {
        this.setloginModal(true);
        return;
      }
      //如果开箱为运行状态则不运行
      if (this.isAwardRunning) return;
      this.isAwardRunning = true; //设置状态
      this.award_people_awards = [];
      this.AwardPlayersIdList = [];
      await this.case_opened_awards.forEach((items) => {
        this.AwardPlayersIdList.push(items.AwardPlayersId);
        let multiplePeople_index = this.MPIdList.indexOf(items.AwardPlayersId);
        if (multiplePeople_index > -1) {
          this.award_people_awards.push(
            this.MultiplePeopleList[multiplePeople_index]
          );
        }
      });
      await this.$nextTick();
      //开箱开始运行
      await this.$refs.multiplePeople_people_open_box.start(
        this.award_people_awards[0]
      );
      await this.playStartAudio();
    },
    playStartAudio() {
      if (!this.isMute && !this.is_jump_case_open_animation) {
        this.sounds["open"].currentTime = 0;
        this.sounds["open"].play();
        this.sounds["run"].currentTime = 0;
        this.sounds["run"].playbackRate = 1.8;
        this.sounds["run"].play();
      }
    },
    async on_multiplePeople_opened() {
      this.isAwardRunning = false; //设置开箱运行状态
      // await this.$refs.mpcase_reward_ui.reset();

      let player_item = await this.players.filter((res) => {
        return this.AwardPlayersIdList.indexOf(res.id) > -1;
      });
      //这里就新需求要求所有呈现都以未参与者呈现
      if (this.AwardPlayersIdList.indexOf(this.curUserRealId) > -1 && false) {
        //如果自己是参与者
        await player_item[0].awardItems.forEach(async (award_item) => {
          await this.$refs.mpcase_reward_ui.pushItem(
            award_item.name,
            award_item.mSerial,
            award_item.picture,
            award_item.rarity,
            award_item.price,
            award_item.hasBeenSold,
            "",
            award_item.isGarbageAward,
            player_item[0].name
          );
        });
        if (!this.isMute) {
          if (
            player_item[0].awardItems.filter((_) => !_.isGarbageAward).length >
            0
          ) {
            this.sounds["win"].currentTime = 0;
            this.sounds["win"].play();
          } else {
            this.sounds["lose"].currentTime = 0;
            this.sounds["lose"].play();
          }
        }
      } else {
        //如果不是
        await this.case_opened_awards.forEach(async (award_item) => {
          await this.$refs.mpcase_reward_ui.pushItem(
            award_item.itemname,
            award_item.mSerial,
            award_item.itempic,
            award_item.rarity,
            award_item.price,
            true,
            "",
            true,
            award_item.awardPlayerName
          );
        });
        if (!this.isMute) {
          this.sounds["win"].currentTime = 0;
          this.sounds["win"].play();
        }
      }
      // await this.$refs.mpcase_reward_ui.show();
      // this.$refs.mpcase_reward_ui.isShow = true;
      this.isOverShow = true;
      this.currentMPCTabs = 2;
    },
    toggleMultiplePeopleAnimation() {
      sessionStorage.setItem(
        "is_jump_multiplePeople_animation",
        String(this.is_jump_multiplePeople_animation)
      );
    },
    onCloseRewardHandle() {
      this.$emit("onCloseRewardHandle");
    },
  },
};
